export default {"src":"/_next/static/media/container.7c1b52a1.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};